import { doUntilDone, displayPipSizeToDecimalPlaces } from '../bot/tools';
import TicksService from './TicksService';

const eventSymbol = payload => payload.symbol || payload.underlying_symbol;

export default class ChartTicksService extends TicksService {
    observe() {
        this.api.events.on('tick', r => {
            const { tick } = r;
            const symbol = eventSymbol(tick);
            const { id } = tick;
            const places = displayPipSizeToDecimalPlaces(tick.pip_size);

            if (Number.isInteger(places)) {
                this.rememberPipSize(symbol, places);
            }

            if (symbol && this.ticks.has(symbol)) {
                this.subscriptions = this.subscriptions.setIn(['tick', symbol], id);
                this.updateTicksAndCallListeners(symbol, r);
            }
        });

        this.api.events.on('ohlc', r => {
            const { ohlc } = r;
            const symbol = eventSymbol(ohlc);
            const { granularity, id } = ohlc;
            const places = displayPipSizeToDecimalPlaces(ohlc.pip_size);

            if (Number.isInteger(places)) {
                this.rememberPipSize(symbol, places);
            }

            if (symbol && this.candles.hasIn([symbol, Number(granularity)])) {
                this.subscriptions = this.subscriptions.setIn(['ohlc', symbol, Number(granularity)], id);
                const address = [symbol, Number(granularity)];
                this.updateCandlesAndCallListeners(address, r);
            }
        });
    }

    requestTicks(options) {
        const { symbol, granularity, style } = options;

        return new Promise((resolve, reject) => {
            doUntilDone(() =>
                this.api.getTickHistory(symbol, {
                    subscribe  : 1,
                    end        : 'latest',
                    count      : 1000,
                    granularity: granularity ? Number(granularity) : undefined,
                    style,
                })
            )
                .then(r => {
                    const places = displayPipSizeToDecimalPlaces(r.pip_size);
                    if (Number.isInteger(places)) {
                        this.rememberPipSize(symbol, places);
                    }

                    if (style === 'ticks') {
                        this.updateTicksAndCallListeners(symbol, r);
                        resolve(r);
                    } else {
                        this.updateCandlesAndCallListeners([symbol, Number(granularity)], r);
                        resolve(r);
                    }
                })
                .catch(reject);
        });
    }
}
